import { graphql } from "relay-runtime"
import { useBetterDocMutation } from "@/modules/admin/better-doc/hooks/useBetterDocMutation"
import { useSendBetterDocReferralSlipMutation as useSendBetterDocReferralSlipMutationType } from "@/modules/admin/better-doc/services/__generated__/useSendBetterDocReferralSlipMutation.graphql"

const mutation = graphql`
  mutation useSendBetterDocReferralSlipMutation($input: De_sendBetterDocReferralSlipInput!) {
    de_sendBetterDocReferralSlip(input: $input) {
      actionResult: de_BetterDocSessionActionResult {
        sessionId
        isSuccessful
        httpStatusCode
        betterDocState
        caseId
        errorReason
        exchangeId
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export type BetterDocSessionActionResult = NonNullable<
  useSendBetterDocReferralSlipMutationType["response"]["de_sendBetterDocReferralSlip"]["actionResult"]
>

export const useSendBetterDocReferralSlipMutation = () => {
  return useBetterDocMutation<useSendBetterDocReferralSlipMutationType>(mutation)
}
